module.exports = __webpack_public_path__ + "static/media/correct-1.dd588a05.m4a";